export default [
  {
    path: '/frais-scolaire',
    name: 'frais-scolaire-list',
    props: true,
    component: () => import('@/views/schoolFees/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des frais scolaire',
      breadcrumb: [
        {
          text: 'Frais scolaire',
        },
        {
          text: 'Liste des frais scolaire',
          active: true,
        },
      ],
    },
  },
  {

    path: '/frais-scolaire/create',
    name: 'frais-scolaire-add',
    props: true,
    component: () => import('@/views/schoolFees/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Ajouter frais scolaire',
      breadcrumb: [
        {
          text: 'Frais scolaire',
        },
        {
          text: 'Ajouter frais scolaire',
          active: true,
        },
      ],
    },
  },

  {

    path: '/frais-scolaire/edit/:id',
    name: 'frais-scolaire-edit',
    props: true,
    component: () => import('@/views/schoolFees/Edit.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Modifier frais scolaire',
      breadcrumb: [
        {
          text: 'Frais scolaire',
        },
        {
          text: 'Modifier frais scolaire',
          active: true,
        },
      ],
    },
  },

]
